import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { isNumber } from 'lodash';
import { ISelectOption } from '../../form-master/components/select-field/select-field.interface';

export const termsKey = 'TERMS';
export const CUSTOM_TERMS_VALUE = 999;
export const MAX_TERMS = 365;
export const MIN_TERMS = 0;

export const termsValues: List<ISelectOption> = List([
  {
    key: 'DATE.TERMS.SAME_DAY',
    value: 0,
    trackingValue: 0,
  },
  {
    key: 'DATE.TERMS.7_DAYS',
    value: 7,
    trackingValue: 7,
  },
  {
    key: 'DATE.TERMS.14_DAYS',
    value: 14,
    trackingValue: 14,
  },
  {
    key: 'DATE.TERMS.21_DAYS',
    value: 21,
    trackingValue: 21,
  },
  {
    key: 'DATE.TERMS.30_DAYS',
    value: 30,
    trackingValue: 30,
  },
  {
    key: 'DATE.TERMS.45_DAYS',
    value: 45,
    trackingValue: 45,
  },
  {
    key: 'DATE.TERMS.60_DAYS',
    value: 60,
    trackingValue: 60,
  },
  {
    key: 'DATE.TERMS.90_DAYS',
    value: 90,
    trackingValue: 90,
  },
]);

export function termsLocalized(
  translateService: TranslateService,
  withNoneOption?: boolean,
  customTerms?: number,
  canAddCustomTerms?: boolean
): List<ISelectOption> {
  let values: List<ISelectOption> = termsValues;

  if (
    isNumber(customTerms) &&
    !values.some(
      (termOption: ISelectOption) => termOption.value === customTerms
    )
  ) {
    values = values
      .push({
        key:
          customTerms === 1
            ? translateService.instant('DATE.ONE_DAY')
            : translateService.instant('DATE.N_DAYS', { number: customTerms }),
        value: customTerms,
        trackingValue: customTerms,
      })
      .sortBy(
        (termOption: ISelectOption) => termOption.value
      ) as List<ISelectOption>;
  }

  if (withNoneOption) {
    values = values.unshift({
      key: 'DATE.TERMS.NONE',
      value: null,
      trackingValue: -1,
    });
  }

  if (canAddCustomTerms) {
    values = values.push({
      key: 'DATE.TERMS.CUSTOM',
      value: CUSTOM_TERMS_VALUE,
      trackingValue: 'custom',
    });
  }

  return values.map((term) => {
    return {
      key: translateService.instant(term.key),
      value: term.value,
      trackingValue: term.trackingValue,
      e2eId: `terms-${term.value}`,
    };
  }) as List<ISelectOption>;
}
